import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject,ReplaySubject } from 'rxjs';

@Injectable()
export class AppStateService {

  loaderState = false;
  public loaderState$ = new BehaviorSubject(this.loaderState);
  public categoryList$ = new ReplaySubject<string[]>(1);
  public categoriesData$ = new ReplaySubject<Object>(1);
  public activeCategory$ = new ReplaySubject<string>(1);
  public result$ = new BehaviorSubject({ score: 45 });
  constructor() { }

  setloaderState(state: boolean): any {
    this.loaderState$.next(state);
  }

  getloaderState(): Observable<any> {
    return this.loaderState$.asObservable();
  }

  setCategoryList(list: Array<string>): any {
    this.categoryList$.next(list);
  }

  getCategoryList(): Observable<Array<string>> {
    return this.categoryList$.asObservable();
  }

  setCategoriesData(data: object): any {
    this.categoriesData$.next(data);
  }

  getCategoriesData(): Observable<object> {
    return this.categoriesData$.asObservable();
  }

  setActiveCategory(cat: string): any {
    this.activeCategory$.next(cat);
  }

  getActiveCategory(): Observable<string> {
    return this.activeCategory$.asObservable();
  }

  setResult(result: any): any {
    this.result$.next(result);
  }

  getResult(): Observable<any> {
    return this.result$.asObservable();
  }
}
